import { SET_ERROR } from "../actions/actionTypes";

const initialState = {
  error: '',
  code: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ERROR:
      return {
        ...state,
        error: action.error,
        code: action.code
      };
    default:
      return state;
  }
};

export default reducer;